module.exports = __webpack_public_path__ + "static/media/nptel.55872e8d.png";